// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__CE7Un","fixedAvatarSize":"styles_fixedAvatarSize__u5_YC"};